import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { MaterialModule } from './material/material.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask, IConfig } from 'ngx-mask';
import { IMaskModule } from 'angular-imask';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FileuploadComponent } from './components/fileupload/fileupload.component';
import { OnlynumericDirective } from './directives/onlynumeric.directive';
import { OnlydateDirective } from './directives/onlydate.directive';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete-component.component';
const maskConfig: Partial<IConfig> = {
  validation: false,
};
@NgModule({
  declarations: [LoaderComponent,FileuploadComponent,OnlynumericDirective, OnlydateDirective],
  imports: [
    CommonModule,
    MaterialModule,
    IMaskModule,
    FlexLayoutModule,
    NgxMaskDirective, // Reemplaza a NgxMaskModule.forRoot(...)
    NgxMaskPipe,       // Agregado si usas pipes de máscara en templates
    AutoCompleteComponent
  ],
  exports : [
    LoaderComponent,
    FileuploadComponent,
    MaterialModule,
    IMaskModule,
    NgxMaskDirective, // Reemplaza a NgxMaskModule
    FlexLayoutModule,
    OnlynumericDirective,
    OnlydateDirective,
    AutoCompleteComponent
  ],
  providers: [
    provideNgxMask(maskConfig) // Aquí se define la configuración global
  ]
})
export class SharedModule { }
